module.exports = __webpack_public_path__ + "543eb5d8712a7689775fc1dbef5692c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/name-male-4.svg
// module id = 90
// module chunks = 0